module.exports = __webpack_public_path__ + "static/GudJob-3c2b78e005a75a27e83c79d980ac32b5.png";